import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import CustomerSettingSidebar from '../layouts/CustomerSettingSidebar'
import {MaterialReactTable} from 'material-react-table';
// import FeatherIcon from 'feather-icons-react';
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
// import { useFormik } from "formik";
import axios from "../api/axios";
import Swal from 'sweetalert2';

import { Apitoken, Authtoken } from "../Global";
import { MenuItem } from "@mui/material";
const CustomerUsers = () => {
  let customer_id = localStorage.getItem("customer_id");
  let auth_id = localStorage.getItem("auth_id");
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState({});
   const formData = ({
     customer:customer_id,    
   });
   console.log(auth_id);
   console.log(formData);
   useEffect(() => {
     axios.post("/customerportal/users",formData,{  headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },})
       .then((response) => {
        
         if (response.data.code === 200) {
           setData(response.data.data.users);
         }
         else  if (response.data.code === 401) {
          // window.location.href = "/customerportal/login";
         }else{
         //  window.location.href = "/customerportal/login"; 
         }
       })
       .catch((error) => {
         console.log(error);
       });
   }, []);


  const toggleMobileMenu = () => {
    setMenu(!menu)
  }
  const columns =
 [
    {
      accessorKey: 'user_first_name', //normal accessorKey
      header: 'First Name',
    },
    {
      accessorKey: 'user_last_name', //normal accessorKey
      header: 'Last Name',
    },
    {
      accessorKey: 'user_email', //normal accessorKey
      header: 'Email Address',
    },
    {
      accessorKey: 'user_function', //normal accessorKey
      header: 'Function',
    },
   
  ];
  


const editItem = (item)=>{
  window.location.href = "/customerportal/users-edit/"+item;
}



const deleteItem = (item) => {

  if(auth_id == item){
    Swal.fire(
      'Warning!',
      'You can not delete own account',
      'error'
    );
  }else{
    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/customerportal/users/delete/${item}`, {
              headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                //setBackendSuccess(response.data.message);
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/customerportal/users";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        
      }
    });
  }


}


  return (
    <div className={`main-wrapper customer-portal-main  ${menu ? 'slide-nav': ''}`}> 
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar /> 
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-6">
                <h3 className="page-title">Update Profile</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Update Profile</li>
                </ul>
              </div>
            </div>
          </div>
        
          <div className="row">
            <div className="col-xl-2 col-md-3">
              <CustomerSettingSidebar />
            </div>
            
            <div className="col-xl-10 col-md-9">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">User Information</h5>
                </div>
                <div className="card-body">
                   <div className="col-auto">
                              <Link to="/customerportal/users-add" className="btn btn-primary me-1">
                              <i className="fas fa-plus"></i>
                            </Link>
                      </div>
                <div className="table-responsive">
                  <MaterialReactTable columns={columns} data={data} 
                     enableColumnOrdering
                     enablePinning
                     enableRowActions
                     //renderColumnActionsMenuItems 
                   
                        renderRowActionMenuItems={({ row }) => [
                            1 === 1 && (
                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                Edit
                              </MenuItem>
                            ),
                            1 === 1 && (
                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                Delete
                              </MenuItem>
                            ),
                          ]}
        
                  />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>		
  );
}

export default CustomerUsers;